// shared/formly-fields/formly-field-primeng-radiogroup.component.ts
import { Component } from '@angular/core';
import { FormControl } from '@angular/forms'; // Importa FormControl
import { FieldType, FieldTypeConfig } from '@ngx-formly/core'; // Importa FieldTypeConfig
import { isObservable, map, of } from 'rxjs'; // Per gestire le opzioni come Observable


@Component({
  selector: 'formly-field-primeng-radiogroup',
  styleUrls: ['../../config-page/config-page.component.scss'],
  template: `
  <div class="formly-primeng-radiogroup mt20 mB10">
      <strong><label *ngIf="to.label" class="form-label">{{ to.label }}</label></strong>
      <div class="p-field-radiobutton-group">
          <div class="p-field-radiobutton" *ngFor="let option of (options$ | async)">
              <p-radioButton [value]="option.value" [label]="option.label" [formControl]="formControlTyped"
                  [name]="radioGroupName" [formlyAttributes]="field"> </p-radioButton>
          </div>
      </div>
  </div>
  <p-divider></p-divider>`, 
})
export class FieldPrimengRadiogroupComponent extends FieldType {

  get formControlTyped(): FormControl {
      return this.formControl as FormControl;
  }

  get options$() {
    const opts = this.to.options;
    return isObservable(opts)
      ? opts.pipe(map((options: any[] | null) => options ?? []))
      : of(opts ?? []);
  }

   get radioGroupName(): string {
       return this.field.name || this.field.id || '';
   }
}